/**
 * This is the name used in the shader generated by the system to handle uniform buffer instancing.
 */
export const uniformBufferInstanceBufferName = "instanceData";
/**
 * This is the identifying name used as the active atttribute
 * that determines if an instance is rendered or not.
 */
export const activeAttributeName = "_active";
/**
 * Constant that can convert a number expressed in degrees to radians by multiplying
 */
export const TO_RADIANS = Math.PI / 180;
/**
 * Constant that can convert a number expressed in radians to degrees by multiplying
 */
export const TO_DEGREES = 180 / Math.PI;
